export default __webpack_public_path__ + "static/media/headultrasonic.62bc6fba.svg";